
import { i18n, setLanguageAsync } from "@/i18n";
import axios from "axios";
import { onBeforeMount } from "vue";
import { ref } from "vue";
import { defineComponent } from "vue";
import { useRoute } from "vue-router";
import SurveyAnswer from "@/components/SurveyAnswer.vue";
import { Delta } from "quill";
import { QuillDeltaToHtmlConverter } from "quill-delta-to-html";

export default defineComponent({
	components: { SurveyAnswer },
	setup() {
		const route = useRoute();

		onBeforeMount(async () => {
			setLanguage();
			await getThankYouTitle();
			await getThankYouTextDelta();
			await getThankYouText();
			await getShowSummary();
			loading.value = false;
		});

		const thankYouTitle = ref("");
		const thankYouText = ref("");
		const thankYouTextDelta = ref("");
		const loading = ref(true);
		const showAnswers = ref(false);
		const showAnswersModal = ref(false);

		const getThankYouTitle = async () => {
			try {
				const response = await axios.get<string>(
					`survey/thankYouTitle/${route.params["code"]}/${i18n.global.locale}`,
					{
						headers: {
							organization: route.params["org"],
						},
					}
				);
				if (response?.data) thankYouTitle.value = response.data;
			} catch (ex: unknown) {
				console.log("Problem fetching thank you -title");
			}
		};

		const getThankYouTextDelta = async () => {
			try {
				const response = await axios.get<string>(
					`survey/thankYouTextDelta/${route.params["code"]}/${i18n.global.locale}`,
					{
						headers: {
							organization: route.params["org"],
						},
					}
				);
				thankYouTextDelta.value = response.data;
			} catch (ex: unknown) {
				console.log("Problem fetching thank you -text");
			}
		};

		const getThankYouText = async () => {
			try {
				const response = await axios.get<string>(
					`survey/thankYouText/${route.params["code"]}/${i18n.global.locale}`,
					{
						headers: {
							organization: route.params["org"],
						},
					}
				);
				thankYouText.value = response.data;
			} catch (ex: unknown) {
				console.log("Problem fetching thank you -text");
			}
		};

		const getShowSummary = async () => {
			try {
				const response = await axios.get<boolean>(
					`survey/showSummary/${route.params["code"]}`,
					{
						headers: {
							organization: route.params["org"],
						},
					}
				);
				showAnswers.value = response.data;
			} catch (ex: unknown) {
				console.log("Problem fetching show summary -data");
			}
		};

		const setLanguage = () => {
			let lang = route.params["lang"] as "fi" | "sv" | "en" | undefined;
			if (lang) setLanguageAsync(lang);
		};

		const quillToHtml = (input?: string | Delta | null) => {
			let delta: Delta;

			if (input == null || input == undefined || input == "") {
				return "";
			}

			if (typeof input == "string") {
				// eslint-disable-next-line no-control-regex
				const regex = new RegExp("[\u0000-\u001F\u007F-\u009F]", "g");
				const inputFixed = input.replace(regex, "");
				delta = JSON.parse(inputFixed) as Delta;
			} else {
				delta = input;
			}

			if (!delta.ops) {
				return "";
			}

			const converter = new QuillDeltaToHtmlConverter(delta.ops) as any;
			return converter.convert();
		};

		return {
			thankYouTitle,
			thankYouText,
			thankYouTextDelta,
			loading,
			showAnswers,
			showAnswersModal,
			quillToHtml,
		};
	},
});
